import { Availability } from '../AvailabilityView';
import { Box, Container } from '@chakra-ui/react';
import { PickerEmptyState, PickerField, PickerRow } from './pickerUi';
import { useEffect, useState } from 'react';

export const PickerKI = (props: any) => {
	const [isValidating] = useState(false);
	const [subject, setSubject] = useState('');
	const [school, setSchool] = useState('');
	const [grade, setGrade] = useState('');
	const [level, setLevel] = useState('');
	const [isMobileCollapsed, setIsMobileCollapsed] = useState(false);
	const isFilled = Boolean(subject && school && grade && (school === 'SP' ? true : level));

	useEffect(() => {
		if (isFilled) setIsMobileCollapsed(true);
	}, [isFilled]);

	const handleSubjectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextSubject = event.currentTarget.value;
		setSubject(nextSubject);
		setSchool('');
		setGrade('');
		setLevel('');
	};

	const handleSchoolChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextSchool = event.currentTarget.value;
		setSchool(nextSchool);
		setGrade('');
		setLevel('');
	};

	const getCode = () => {
		const suffix = school === 'SP' ? 'PP' : level;
		return `${subject}_ind_${suffix}`;
	};

	const renderGradesForSchool = (school: any) => {
		let limit = 0;
		switch (school) {
			case 'SP':
				limit = 8;
				break;
			case 'LIC':
				limit = 4;
				break;
			case 'TECH':
				limit = 5;
				break;
		}
		return [...Array(limit)].map((_, idx) => (
			<option value={String(idx + 1)} key={idx}>
				{idx + 1}
			</option>
		));
	};

	return (
        <Box pb={2}>
            <PickerRow
                collapsible={isFilled}
                isCollapsed={isMobileCollapsed}
                onToggleCollapse={() => setIsMobileCollapsed((value) => !value)}
            >
                <PickerField
                    label="Przedmiot"
                    value={subject}
                    invalid={!subject && isValidating}
                    placeholder="- przedmiot -"
                    onChange={handleSubjectChange}
                >
                    <option value="mat">matematyka</option>
                    <option value="pol">j. polski</option>
                    <option value="ang">j. angielski</option>
                    <option value="fiz">fizyka</option>
                    <option value="chemia">chemia</option>
                    <option value="geo">geografia</option>
                    <option value="bio">biologia</option>
                </PickerField>
                <PickerField
                    label="Typ szkoły"
                    value={school}
                    invalid={!school && isValidating}
                    placeholder="- typ szkoły -"
                    onChange={handleSchoolChange}
                >
                    <option value="SP">szkoła podstawowa</option>
                    <option value="LIC">liceum</option>
                    <option value="TECH">technikum</option>
                </PickerField>
                <PickerField
                    label="Klasa"
                    value={grade}
                    invalid={!grade && isValidating}
                    placeholder="- klasa -"
                    onChange={(event) => setGrade(event.currentTarget.value)}
                >
                    {renderGradesForSchool(school)}
                </PickerField>
                <PickerField
                    label="Poziom"
                    value={level}
                    invalid={!level && isValidating && school !== 'SP'}
                    placeholder="- poziom -"
                    onChange={(event) => setLevel(event.currentTarget.value)}
                    disabled={school === 'SP'}
                >
                    {school === 'SP' ? null : (
                        <>
                            <option value="PP">podstawowy</option>
                            <option value="PR">rozszerzony</option>
                        </>
                    )}
                </PickerField>
            </PickerRow>
            {isFilled ? (
				<Availability
					code={getCode()}
					type="KI"
					onPick={(lesson: any) =>
						props.onPick({
							...lesson,
							subjectCode: subject,
							kind: 'Korepetycje indywidualne',
							student: {
								school,
								grade,
								level: school === 'SP' ? '' : level,
							},
						})
					}
				/>
			) : (
				<Container centerContent>
					<PickerEmptyState />
				</Container>
			)}
        </Box>
    );
};
